import React, { useState } from 'react';
import type { PlayerSquareProps, PublicPlayerProps, SquareOfferProps, SquareProps } from '../../types';
import { SquaresApi } from '../api';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';
import { showConfirmAlert } from '../../Components/ConfirmAlert';
import { Image } from 'react-native';

type SquareOfferCardProps = { 
    player_id?:string, 
    square:SquareProps, 
    offer_owner?:PublicPlayerProps,
    player_square:PlayerSquareProps, 
    square_offer:SquareOfferProps, 
    home_abbr?:string,
    away_abbr?:string,
    onRequestAuthenticate: () => void
}
const SquareOfferCard = ({ player_id, offer_owner, square, player_square, square_offer, away_abbr, home_abbr, onRequestAuthenticate }: SquareOfferCardProps ) => {
    const Colors = useColors();
    const [ loading, setLoading ] = useState(false);
    const [ hidden, setHidden ] = useState(false);
    const handleResponse = async(response:string) => {
        if(loading){ return  } //No mashymashy
        if(!player_id){ onRequestAuthenticate() }
        setLoading(true)
        switch(response){
            case 'accepted':
                await SquaresApi.offserSquare({ ...square_offer, status: 'accepted' })
                break
            case 'rejected':
                if(square_offer.buy_sell_ind == 'sell'){ return setHidden(true) }
                await SquaresApi.offserSquare({ ...square_offer, status: 'rejected' })
                break
            case 'withdrawn':
                await SquaresApi.offserSquare({ ...square_offer, status: 'withdrawn' })
                break
            default: break
        }
        setLoading(false)
    }

    const handleConfirmResponse = (response:string) => {
        showConfirmAlert('Are you sure?', 'Your response is final and cannot be modified',
            () => handleResponse(response),
            () => console.log('')
        )
    }
    
    if(hidden){ return <></> }
    
    const cl = square_offer.market_type === 'FOR_MONEY' ? '$' : 'E'
    const mine = square_offer.offerer_id == player_id ? true : false
    return (
        <View float style={{ minWidth:250, maxWidth:275, flexGrow:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius: 8, borderTopLeftRadius:8}}>
                {offer_owner ?
                <View float style={{ padding:2, marginRight:5, borderRadius:100 }}>
                    <Image
                        source={{ uri:offer_owner.profile_pic }}
                        style={{ height:35, width:35, borderRadius:100 }}
                        resizeMode='cover'
                    />
                </View>
                :<></>}
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Squares{square_offer.buy_sell_ind === 'sell'?' Sale':' Buy'} Offer</Text>
                    {square_offer.buy_sell_ind == 'sell' && mine ?
                    <Text theme='description'>This is your sell offer. Other players can buy this square for the price noted below</Text>
                    : square_offer.buy_sell_ind == 'sell' && !mine ?
                    <Text theme='description'>This is a sale offer from another user. You can buy their square for the stated price right now</Text>
                    :square_offer.buy_sell_ind == 'buy' && !mine ?
                    <Text theme='description'>This is an offer from another user to purchase your square.  Sell or reject the offer below</Text>
                    :
                    <Text theme='description'>This is your buy offer.  The owner can accept or reject your offer</Text>
                    }
                </View>
            </View>
            <View transparent type='body' style={{ padding:5, flexGrow:1 }}>
                <View transparent type='row' style={{ padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                    <Text style={{ flex:1 }} theme='description'>Square</Text>
                    <Text theme='h2'>{home_abbr??''}: {square.square_score_x}, {away_abbr??''}: {square.square_score_y}</Text>
                </View>
                <View transparent type='row' style={{ padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                    <Text style={{ flex:1 }} theme='description'>Purchased For</Text>
                    <Text theme='h2'>{cl}{player_square.purchase_price.toFixed(2)}</Text>
                </View>
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{ flex:1 }} theme='description'>Offer Amount</Text>
                    <Text theme='h1' color={Colors.text.success}>{cl}{square_offer.amount.toFixed(2)}</Text>
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', borderBottomRightRadius:8, borderBottomLeftRadius:8, padding:10 }}>
                {mine ?
                <View type='row' transparent style={{ flex:1 }}>
                    <Button 
                        type='error'
                        loading={loading}
                        title='WITHDRAW'
                        style={{flex:1, padding:12, opacity: loading?0.5:1 }} onPress={() => handleConfirmResponse('withdrawn')}
                    />
                </View>
                :
                <View type='row' transparent style={{ flex:1 }}>
                   <Button 
                        style={{flex:1, padding:12, opacity: loading?0.5:1  }} 
                        type='error'
                        loading={loading}
                        title='DECLINE'
                        onPress={() => handleConfirmResponse('rejected')}
                    />
                   <Button 
                        type='success'
                        loading={loading}
                        title='ACCEPT'
                        style={{flex:1, padding:12, marginLeft:5, opacity: loading?0.5:1 }} onPress={() => handleConfirmResponse('accepted')}
                    />
                </View>
                }
            </View>
            
        </View>
    )
}


export default SquareOfferCard